export default __webpack_public_path__ + "static/card4-7c1b8de2617e58059fb2f05a2a8f2388.png";